var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterK(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8208,
    cy: 12,
    r: 12,
    fill: "#FAF0E1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8208,
    cy: 12,
    r: 11.5,
    stroke: "#D7A459",
    strokeOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.268 16.012C17.359 16.012 17.437 15.999 17.502 15.973V17C17.385 17.013 17.294 17.026 17.229 17.026C16.501 17.026 15.903 16.818 15.435 16.402C14.954 15.999 14.317 15.18 13.498 13.971L12.601 12.645L11.223 14.023V17H10.118V7.965H11.223V12.632L15.786 7.965H17.203L13.394 11.852L14.512 13.477C15.188 14.465 15.708 15.128 16.085 15.479C16.449 15.83 16.839 16.012 17.268 16.012Z",
    fill: "#D7A459"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterK);
export default __webpack_public_path__ + "static/media/letterK.bbda457a717d9454319db41e2fe6a57c.svg";
export { ForwardRef as ReactComponent };